export default "__VITE_ASSET__Dc$3JlGV__"